<script>
  import { ChevronDown, Icon } from "svelte-hero-icons";
  import { clickOutside } from "$utils/clickOutside";

  export let buttonText = "";
  export let buttonClass = "";
  export let onOpen = () => {}; // Dropdown about to open (can be delayed)
  export let onClick = () => {}; // Click on "main button"
  export let disabled = false;
  export let hasSeperateDropdown = false;
  export let disableClickOutside = false;
  export let width = null; // Optional custom width

  let showDropdown = false;

  async function toggleDropdown() {
    if (!showDropdown) {
      await onOpen();
    }
    showDropdown = !showDropdown;
  }

  function closeDropdown() {
    showDropdown = false;
  }
</script>

<div
  class="relative inline-block"
  use:clickOutside
  on:clickoutside={disableClickOutside ? () => {} : closeDropdown}
>
  <div
    class="flex items-stretch text-sm bg-surface-muted text-content border border-line-strong rounded-md"
    class:hover:bg-surface-hover={!hasSeperateDropdown}
  >
    <button
      class="flex px-2 py-0.5 items-center border-line-strong rounded-md-l hover:bg-surface-hover disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-surface-hover {buttonClass}"
      class:border-r={hasSeperateDropdown}
      {disabled}
      on:click={(e) => {
        if (hasSeperateDropdown) {
          onClick(e, { toggleDropdown });
        } else {
          toggleDropdown();
        }
      }}
    >
      <slot name="prefix" {disabled} />
      {#if buttonText}
        <span class="truncate max-w-32">{buttonText}</span>
      {/if}
    </button>

    {#if hasSeperateDropdown}
      <button
        class="flex px-1 py-0.5 items-center cursor-pointer rounded-md-r hover:bg-surface-hover"
        on:click={toggleDropdown}
      >
        <Icon src={ChevronDown} class="w-4 h-4" />
      </button>
    {/if}
  </div>

  {#if showDropdown}
    <div
      class="absolute z-50 right-0 top-6 mt-2 p-4 min-w-80 border border-line-strong bg-surface rounded-md shadow {width
        ? `w-[${width}]`
        : ''}"
    >
      <slot name="content" close={closeDropdown} />
    </div>
  {/if}
</div>
